import { values } from '../_helpers'

const _enum = {
  low: 0,
  mediumMinus: 1,
  medium: 2,
  mediumPlus: 3,
  high: 4,
  NA: 5
}

const tannins = { ..._enum, name: 'tannins', values: values(_enum) }

export {
  tannins
}
